import { ControlFacet } from '../models/controls/ControlFacet';
import { IComponentAs } from '@uifabric/utilities/lib/IComponentAs';
import { defaultRenderComponentOption } from '../components/controls/defaultRenderComponentControlOption';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';

export interface IFileTypeIconControlProps {
  itemKey: string | undefined;
}

export interface IFileTypeIconControlOverrides {
  iconAs: IComponentAs<IIconProps>;
}

export const itemFileTypeIconControl = new ControlFacet<
  IFileTypeIconControlProps,
  IFileTypeIconControlOverrides
  >('itemFileTypeIconControl', {
    iconAs: defaultRenderComponentOption<IIconProps>()
  });
